<odl-dialog
  class="unanswered-questions-dialog"
  [label]="'QUESTIONS.UNANSWERED_TITLE' | translate"
  [open]="isWarningOpen()"
  (odl-close)="closeWarning()"
>
  <p class="message">{{ 'QUESTIONS.UNANSWERED_REQUIRED' | translate }}</p>
  <div slot="footer" class="footer">
    <odl-button variant="primary" (click)="closeWarning()">{{ 'OK' | translate }}</odl-button>
  </div>
</odl-dialog>

<odl-dialog
  class="unanswered-questions-confirmation"
  [label]="'QUESTIONS.UNANSWERED_TITLE' | translate"
  [open]="isConfirmationOpen()"
  (odl-close)="cancel()"
>
  <p class="message">{{ 'QUESTIONS.UNANSWERED_CONFIRM' | translate }}</p>
  <odl-checkbox [checked]="dontAskAgain()" (odl-input)="toggleDontAskAgain($event)">
    {{ 'QUESTIONS.DONT_SHOW_AGAIN' | translate }}
  </odl-checkbox>
  <div slot="footer" class="footer">
    <odl-button variant="secondary" class="cancel-button" (click)="cancel()">
      {{ 'CANCEL' | translate }}
    </odl-button>
    <odl-button variant="primary" class="confirm-button" (click)="confirm()">
      {{ 'QUESTIONS.UNANSWERED_CONTINUE' | translate }}
    </odl-button>
  </div>
</odl-dialog>
